module.exports = __webpack_public_path__ + "img/insider_banner_mobile_1x.d06fde82.png";